<template>
  <span>
    <v-btn @click="showDialog" icon color="primary">
      <v-icon>mdi-pencil</v-icon>
    </v-btn>

    <role-dialog
      :showDialog="isDialogVisible"
      :role="role"
      :loading="loading"
      @close="closeDialog"
      @submit="updateRole"
      v-if="isDialogVisible"
    />
  </span>
</template>

<script>
import { mapActions } from "vuex";
import RoleDialog from "./RoleDialog.vue";

export default {
  components: { RoleDialog },
  props: {
    role: {
      type: Object,
      value: () => ({})
    }
  },
  data: () => ({
    loading: false,
    isDialogVisible: false,
  }),
  methods: {
    ...mapActions("roles", { updateRoleStore: "updateRole" }),
    ...mapActions("whizeosupportToolsStore", ["SHOW_SNACKBAR"]),
    showDialog() {
      this.isDialogVisible = true;
    },
    closeDialog() {
      this.isDialogVisible = false;
    },
    async updateRole(role) {
      this.loading = true;

      try {
        await this.updateRoleStore(role);
        this.closeDialog();
      } catch (error) {
        const errorMessage = {
          visible: true,
          color: "error",
          message: "There was a problem while saving the role.",
        };

        this.SHOW_SNACKBAR(errorMessage);
      } finally {
        this.loading = false;
      }
    },
  }
  
}
</script>
